var NumberedListWidget = /** @class */ (function () {
    function NumberedListWidget(widget) {
        this.widget = widget;
        this.init();
    }
    NumberedListWidget.prototype.init = function () {
        // Initialize numbered list widget functionality
        this.setupNumberedList();
    };
    NumberedListWidget.prototype.setupNumberedList = function () {
        var _this = this;
        // Setup accordion functionality
        var listItems = this.widget.querySelectorAll('.rmff-numbered-item');
        listItems.forEach(function (item, index) {
            var itemElement = item;
            var headerElement = itemElement.querySelector('.rmff-numbered-item-header');
            var showMoreLink = itemElement.querySelector('.rmff-show-more-link');
            var showLessLink = itemElement.querySelector('.rmff-show-less-link');
            var nextStepLink = itemElement.querySelector('.rmff-next-step-link');
            var contentElement = itemElement.querySelector('.rmff-numbered-item-text');
            if (headerElement && showMoreLink && showLessLink && contentElement) {
                // Add click handler to header (title + number area)
                headerElement.addEventListener('click', function () {
                    _this.toggleAccordionItem(itemElement, contentElement);
                });
                // Add click handler to Show More link
                showMoreLink.addEventListener('click', function () {
                    _this.toggleAccordionItem(itemElement, contentElement);
                });
                // Add click handler to Show Less link
                showLessLink.addEventListener('click', function () {
                    _this.toggleAccordionItem(itemElement, contentElement);
                });
                // Add click handler to Next Step link if it exists
                if (nextStepLink) {
                    nextStepLink.addEventListener('click', function () {
                        _this.navigateToNextStep(itemElement, nextStepLink);
                    });
                }
                // Add data attributes
                itemElement.setAttribute('data-item-number', (index + 1).toString());
                itemElement.setAttribute('data-accordion-item', 'true');
                // Initially hide content
                itemElement.classList.add('rmff-accordion-closed');
            }
        });
    };
    NumberedListWidget.prototype.toggleAccordionItem = function (itemElement, contentElement) {
        var _this = this;
        var isCurrentlyOpen = itemElement.classList.contains('rmff-accordion-open');
        // Close all other accordion items
        var allItems = this.widget.querySelectorAll('.rmff-numbered-item');
        allItems.forEach(function (item) {
            var itemEl = item;
            if (itemEl !== itemElement) {
                _this.closeAccordionItem(itemEl);
            }
        });
        // Toggle current item
        if (isCurrentlyOpen) {
            this.closeAccordionItem(itemElement);
        }
        else {
            this.openAccordionItem(itemElement, contentElement);
        }
    };
    NumberedListWidget.prototype.openAccordionItem = function (itemElement, contentElement) {
        var _this = this;
        // Temporarily set height to auto to get the natural height
        contentElement.style.height = 'auto';
        var naturalHeight = contentElement.scrollHeight;
        // Reset height to 0 for animation
        contentElement.style.height = '0px';
        // Force reflow
        contentElement.offsetHeight;
        // Add open class and animate to natural height
        itemElement.classList.remove('rmff-accordion-closed');
        itemElement.classList.add('rmff-accordion-open');
        contentElement.style.height = "".concat(naturalHeight, "px");
        // Clean up and scroll after animation completes
        setTimeout(function () {
            if (itemElement.classList.contains('rmff-accordion-open')) {
                contentElement.style.height = 'auto';
                // Scroll to the top of the opened item
                _this.scrollToItem(itemElement);
            }
        }, 300);
    };
    NumberedListWidget.prototype.closeAccordionItem = function (itemElement) {
        var _this = this;
        var contentElement = itemElement.querySelector('.rmff-numbered-item-text');
        if (!contentElement)
            return;
        // Get current height
        var currentHeight = contentElement.scrollHeight;
        // Set explicit height for animation
        contentElement.style.height = "".concat(currentHeight, "px");
        // Force reflow
        contentElement.offsetHeight;
        // Add closed class and animate to 0
        itemElement.classList.remove('rmff-accordion-open');
        itemElement.classList.add('rmff-accordion-closed');
        contentElement.style.height = '0px';
        // Clean up and scroll after animation completes
        setTimeout(function () {
            if (itemElement.classList.contains('rmff-accordion-closed')) {
                contentElement.style.height = '';
                // Scroll to the top of the closed item
                _this.scrollToItem(itemElement);
            }
        }, 300);
    };
    NumberedListWidget.prototype.scrollToItem = function (itemElement) {
        // Get the position of the item relative to the viewport
        var rect = itemElement.getBoundingClientRect();
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        // Calculate the absolute position of the item
        var itemTop = rect.top + scrollTop;
        // Add offset for better visual positioning
        var offset = this.getScrollOffset();
        // Smooth scroll to the item
        window.scrollTo({
            top: itemTop - offset,
            behavior: 'smooth'
        });
    };
    NumberedListWidget.prototype.getScrollOffset = function () {
        // Base offset that works well on desktop
        var baseOffset = 50;
        // Additional offset to account for fixed mobile navigation height
        var mobileNavOffset = 45;
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        return baseOffset + (isMobile ? mobileNavOffset : 0);
    };
    NumberedListWidget.prototype.navigateToNextStep = function (currentItemElement, nextStepLink) {
        var _this = this;
        var nextIndex = nextStepLink.getAttribute('data-next-index');
        if (!nextIndex)
            return;
        // Close current item
        this.closeAccordionItem(currentItemElement);
        // Find and open next item
        var allItems = this.widget.querySelectorAll('.rmff-numbered-item');
        var nextItemElement = allItems[parseInt(nextIndex)];
        if (nextItemElement) {
            var nextContentElement = nextItemElement.querySelector('.rmff-numbered-item-text');
            if (nextContentElement) {
                // Close all other items first
                allItems.forEach(function (item) {
                    var itemEl = item;
                    if (itemEl !== nextItemElement) {
                        _this.closeAccordionItem(itemEl);
                    }
                });
                // Open the next item
                this.openAccordionItem(nextItemElement, nextContentElement);
            }
        }
    };
    return NumberedListWidget;
}());
// Initialize numbered list widgets when DOM is ready
export function initNumberedListWidgets() {
    var numberedListWidgets = document.querySelectorAll('.rmff-numbered-list-widget');
    numberedListWidgets.forEach(function (widget) {
        new NumberedListWidget(widget);
    });
}
// Export for use in main index.ts
window.NumberedListWidget = NumberedListWidget;
window.initNumberedListWidgets = initNumberedListWidgets;
